import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from '../ui/sonner';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Header />
            <main className="flex-1 pt-20">
                {children}
            </main>
            <Footer />
            <Toaster position="bottom-right" />
        </div>
    );
};

export default Layout;
